import Vue from "vue";
import Router from "vue-router";
import store from "./store/store.js";
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  // base: "/6dd28e9b",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import("./layouts/main/Main.vue"),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "/",
          redirect: "/login",
          // name: "login",
          // component: () => import("./views/LoginPage.vue"),
        },
        {
          path: "/dashboard",
          name: "Dashboard",
          component: () => import("./views/Dashboard.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "/task",
          name: "compCard",
          component: () => import("./views/Task.vue"),
          meta: { requiresAuth: true },
          beforeEnter: (_, _2, next) => {
            if (store.getters.getPermission.task_view) {
              next();
            } else {
              next(false);
            }
          },
        },
        {
          path: "/createtask",
          name: "create-task",
          component: () => import("./views/CreateTask.vue"),
          meta: { requiresAuth: true },
          beforeEnter: (_, _2, next) => {
            if (store.getters.getPermission.task_create) {
              next();
            } else {
              next(false);
            }
          },
        },
        {
          path: "/createtask/:taskid",
          name: "edit-task",
          component: () => import("./views/CreateTask.vue"),
          meta: { requiresAuth: true },
          beforeEnter: (_, _2, next) => {
            if (store.getters.getPermission.task_create) {
              next();
            } else {
              next(false);
            }
          },
        },
        {
          path: "/invoice",
          name: "invoice",
          component: () => import("./views/InvoiceList.vue"),
          meta: { requiresAuth: true },
          beforeEnter: (_, _2, next) => {
            if (store.getters.getPermission.invoice_view) {
              next();
            } else {
              next(false);
            }
          },
        },
        {
          path: "/createinvoice",
          name: "create-invoice",
          component: () => import("./views/CreateInvoice.vue"),
          meta: { requiresAuth: true },
          beforeEnter: (_, _2, next) => {
            if (store.getters.getPermission.invoice_create) {
              next();
            } else {
              next(false);
            }
          },
        },
        {
          path: "/editinvoice/:invoiceid",
          name: "edit-invoice",
          component: () => import("./views/EditInvoice.vue"),
          meta: { requiresAuth: true },
          beforeEnter: (_, _2, next) => {
            if (store.getters.getPermission.invoice_edit) {
              next();
            } else {
              next(false);
            }
          },
        },
        {
          path: "/receipt",
          name: "receipt",
          component: () => import("./views/ReceiptList.vue"),
          meta: { requiresAuth: true },
          beforeEnter: (_, _2, next) => {
            if (store.getters.getPermission.receipt_view) {
              next();
            } else {
              next(false);
            }
          },
        },
        {
          path: "/createreceipt",
          name: "create-receipt",
          component: () => import("./views/CreateReceipt.vue"),
          meta: { requiresAuth: true },
          beforeEnter: (_, _2, next) => {
            if (store.getters.getPermission.receipt_create) {
              next();
            } else {
              next(false);
            }
          },
        },
        {
          path: "/editreceipt/:id",
          name: "edit-receipt",
          component: () => import("./views/EditReceipt.vue"),
          meta: { requiresAuth: true },
          beforeEnter: (_, _2, next) => {
            if (store.getters.getPermission.receipt_edit) {
              next();
            } else {
              next(false);
            }
          },
        },
        {
          path: "/managemember",
          name: "manage-member",
          component: () => import("./views/ManageMember.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "/topup/:id",
          name: "topup-member",
          component: () => import("./views/Topup.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "/createmember",
          name: "create-member",
          component: () => import("./views/CreateMember.vue"),
          beforeEnter: (_, _2, next) => {
            if (store.getters.getPermission.user_add) {
              next();
            } else {
              next(false);
            }
          },
          meta: { requiresAuth: true },
        },
        {
          path: "/createmember/:id",
          name: "edit-member",
          component: () => import("./views/CreateMember.vue"),
          beforeEnter: (_, _2, next) => {
            if (store.getters.getPermission.user_edit) {
              next();
            } else {
              next(false);
            }
          },
          meta: { requiresAuth: true },
        },
        {
          path: "/foldermanagement/:id",
          component: () => import("./views/FolderManagement.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "/manageadmin",
          name: "manage-admin",
          component: () => import("./views/ManageAdmin.vue"),
          beforeEnter: (_, _2, next) => {
            if (store.getters.getPermission.admin_view) {
              next();
            } else {
              next(false);
            }
          },
          meta: { requiresAuth: true },
        },
        {
          path: "/adminsetting",
          name: "admin-setting",
          component: () => import("./views/AdminSetting.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "/accounting",
          name: "accounting",
          component: () => import("./views/AccountingList.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "/createaccounting",
          name: "create-accounting",
          component: () => import("./views/CreateAccounting.vue"),
          meta: { requiresAuth: true },
          beforeEnter: (_, _2, next) => {
            if (store.getters.getPermission.setting_add_owner) {
              next();
            } else {
              next(false);
            }
          },
        },
        {
          path: "/createaccounting/:id",
          name: "edit-accounting",
          component: () => import("./views/CreateAccounting.vue"),
          meta: { requiresAuth: true },
          beforeEnter: (_, _2, next) => {
            if (store.getters.getPermission.setting_edit_owner) {
              next();
            } else {
              next(false);
            }
          },
        },
        {
          path: "/bankpayment",
          name: "bankpayment",
          component: () => import("./views/BankPaymentList.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "/createbankpayment",
          name: "create-bankpayment",
          component: () => import("./views/CreateBankPayment.vue"),
          meta: { requiresAuth: true },
          beforeEnter: (_, _2, next) => {
            if (store.getters.getPermission.setting_add_bank) {
              next();
            } else {
              next(false);
            }
          },
        },
        {
          path: "/createbankpayment/:id",
          name: "edit-bankpayment",
          component: () => import("./views/CreateBankPayment.vue"),
          meta: { requiresAuth: true },
          beforeEnter: (_, _2, next) => {
            if (store.getters.getPermission.setting_edit_bank) {
              next();
            } else {
              next(false);
            }
          },
        },
        {
          path: "/email/:page/:id",
          name: "send-email",
          component: () => import("./views/SendEmail.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "/profile",
          name: "profile",
          component: () => import("./views/Profile.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "/userfile",
          name: "userfile",
          component: () => import("./views/UserFile.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "/userfile/:id",
          name: "userfolder",
          component: () => import("./views/UserFile.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "/detail",
          name: "Detail",
          component: () => import("./views/Detail.vue"),
        },
        // {
        //   path: "/third",
        //   name: "Booking",
        //   component: () => import("./views/Third.vue"),
        // },
        // {
        //   path: "/fourth",
        //   name: "Reciept",
        //   component: () => import("./views/Fourth.vue"),
        // },
        // {
        //   path: "/fourth_2",
        //   name: "Pay Out",
        //   component: () => import("./views/Fourth_2.vue"),
        // },
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/login",
          name: "page-login",
          component: () => import("@/views/pages/Login.vue"),
          meta: { requiresUnAuth: true },
        },
        {
          path: "/logout",
          name: "page-logout",
          component: () => import("@/views/pages/Logout.vue"),
        },
        {
          path: "/pages/error-404",
          name: "page-error-404",
          component: () => import("@/views/pages/Error404.vue"),
        },
        {
          path: "/download",
          name: "download",
          component: () =>
            import("@/views/elements/download-form/downloadInvoiceForm"),
        },
      ],
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404",
    },
  ],
});

router.beforeEach((to, _, next) => {
  if (to.path !== "/login") {
    localStorage.setItem("LS_ROUTE_KEY", to.path);
  }
  if (to.meta.requiresUnAuth && store.getters.getUserId) {
    next(false);
  } else if (to.meta.requiresAuth && !store.getters.getUserId) {
    next("/login");
  } else {
    next();
  }

  // if (to.meta.requiresAuth && !store.getters.getUserId) {
  //   next("/login");
  // } else {
  //   next();
  // }
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
